/* tslint:disable */
/* eslint-disable */
/**
 * data-center
 * data-center
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserFavoriteDashboardRequest
 */
export interface UserFavoriteDashboardRequest {
    /**
     * 
     * @type {string}
     * @memberof UserFavoriteDashboardRequest
     */
    user_id: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserFavoriteDashboardRequest
     */
    is_favorite: boolean;
}

/**
 * Check if a given object implements the UserFavoriteDashboardRequest interface.
 */
export function instanceOfUserFavoriteDashboardRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "user_id" in value;
    isInstance = isInstance && "is_favorite" in value;

    return isInstance;
}

export function UserFavoriteDashboardRequestFromJSON(json: any): UserFavoriteDashboardRequest {
    return UserFavoriteDashboardRequestFromJSONTyped(json, false);
}

export function UserFavoriteDashboardRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserFavoriteDashboardRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'user_id': json['user_id'],
        'is_favorite': json['is_favorite'],
    };
}

export function UserFavoriteDashboardRequestToJSON(value?: UserFavoriteDashboardRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user_id': value.user_id,
        'is_favorite': value.is_favorite,
    };
}

